import "../newTeeSheetTabsDivision.scss";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { ITeeTimeTabNew } from "../NewTeeSheet";
import { findTeeTimeIdClosestToLookbackAnchor } from "../findTeeTimeIdClosestToAnchorMinutes";
import { useTeeSheetNavigationAutoScroll } from "../useTeeSheetNavigationAutoScroll";
import { calculateDivisionColors, INewTeeSheetTabsState, ITeeTimeDraggable } from "../NewTeeSheetTabs";
import { IBookingNote, ITeeTimeBookingCategory, ITeeTimeNew, ITeeTimeSlotNew } from "redux/reducers/models/teetime";
import classNames from "classnames";
import { faCheckCircle, faCircleG, faLocationCheck, faUsdCircle } from "@fortawesome/pro-solid-svg-icons";
import {
  faExclamationCircle,
  faBan,
  faCircle,
  faPersonWalking,
  faPlusCircle,
  faRepeatAlt,
  faThunderstorm,
  faStickyNote,
  faSunrise,
  faSunset,
  faTrophy,
  faUsers,
  faTriangleExclamation,
  faHourglassClock,
  faCircleExclamation,
  faCheck,
  faXmark,
  faUserGroup,
  faUser,
  faPencilLine,
  faChevronRight,
  faTag,
  faPersonGolfing,
  faArrowUTurnUpRight,
  faFlag,
} from "@fortawesome/pro-regular-svg-icons";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { Badge } from "components/badge/Badge";
import BookingSourceLogo from "components/bookingSourceLogo/BookingSourceLogo";
import BookingSourceIcon from "components/bookingSourceLogo/BookingSourceIcon";
import { CustomIcon } from "components/customIcon/CustomIcon";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Spin from "components/spin/spin";
import { convertTime, formatDate } from "helpers/Helpers";
import { isTurnBlockedForEighteenHoles } from "helpers/teeSheetTurn";
import { getTeeTimeSlotWrapJoinClasses } from "helpers/teeSheetSlotWrapJoins";
import { getSunsetLinePlacementTime } from "helpers/sunsetLinePlacementTime";
import moment from "moment";
import { ILeague } from "redux/reducers/models/league";
import { ITournament } from "redux/reducers/models/tournament";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { IDivision } from "redux/reducers/models/facility";
import { SMALL_DESKTOP_WIDTH } from "helpers/ScreenSizes";
import { useDivisionBreakpoints } from "elements/teesheet/useDivisionBreakpoints";
import BookingParticipantName from "elements/teesheet/BookingParticipantName";
import { BookingParticipantTabletLayout } from "elements/teesheet/BookingParticipantTabletLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GetCustomerNotes } from "api/rpc/2024-04/facilityAdmin/customer/customer";
import { StatusCode } from "api/protocols";
import { dequeue, enqueue, showError, showSuccess } from "redux/actions/ui";
import useCancelToken from "hooks/useCancelToken/useCancelToken";
import Portal from "elements/Portal";
import FormLayout from "components/form/FormLayout";
import Sheet from "components/sheet/Sheet";
import useModal from "hooks/modals/useModal";
import Input from "components/form/input/Input";
import SelectNew from "components/select/SelectNew";
import axios, { CancelToken } from "axios";
import { GetPowerCarts, IPowerCart } from "api/rpc/2024-04/facilityAdmin/facility/powercart/powercart";
import { MAX_SEATS_PER_CART } from "../../newTeeSheet/modals/PowerCartNumbersModal";
import { GetBookingNotes, PutBookingParticipant } from "api/rpc/2024-04/facilityAdmin/teesheet/booking";
import { TCustomerNote } from "pages/secure/facility/customer/context/contextTypes";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import GolferCard from "components/bookingPopUp/golferCard/GolferCard";
import Panel from "components/panel/Panel";
import DataTable from "components/dataTable/DataTable";
import Avatar from "components/avatar/Avatar";
import ButtonGroup from "components/buttonGroup/ButtonGroup";
import { ButtonNew as Button } from "components/buttonNew";
import Card from "components/card/Card";
import SignatureCanvas from "react-signature-canvas";
import PaceTracker, { IPaceUpdateResult } from "elements/teesheet/paceTracker/PaceTracker";
import { isSlotOverPace } from "elements/teesheet/paceTracker/paceTrackerUtils";
import "elements/teesheet/paceTracker/paceTracker.scss";
import Markdown from "components/markdown/Markdown";
import Checkbox from "components/form/checkbox/Checkbox";
import Divider from "components/divider";
import SignaturePreview from "components/signaturePad/SignaturePreview";
import SignaturePad from "components/signaturePad/SignaturePad";

interface INewTeeSheetTabsDivisionProps {
  divisionClassName?: string;
  sortedTeeTimes: ITeeTimeTabNew[];
  groupedTeeTimes: ITeeTimeDraggable[];
  teetimeBookingCategories: ITeeTimeBookingCategory[][];
  teeSheetLeagues: ILeague[];
  teeSheetTournaments: ITournament[];
  allDivisions: IDivision[];
  updateMainState(newMainState: Partial<INewTeeSheetTabsState>): void;
  loadTeeSheet: () => Promise<void>;
  navigationKey: string;
}

interface IHighPriorityNoteState {
  notes: Array<TCustomerNote>;
  loading: boolean;
}

interface IPowerCartModal {
  selectedTeeTime: ITeeTimeNew;
  powerCarts: Array<IPowerCart>;
  selectedPowerCarts: Array<ISelectedPowerCarts>;
  highPriorityNotes: Array<TCustomerNote>;
  teeOffTime: string;
  turnTime: string;
  finishTime: string;
  bookingNotes: Array<IBookingNote>;

  //Waiver
  signWaiverPage: boolean;
  waiverParticipant: { booking_participant_id: number; full_name: string; customer_type: string };
  agreeToWaiver: boolean;
  signatureData: string;
  signatureDate: string;
}

interface ISelectedPowerCarts {
  power_cart_id: number;
  power_cart_number: number;
  participant_id: number;
  seat_number: number;
  check_in_status: string;
  original_check_in_status?: string;
}

export default function StarterTeeSheetTabsDivision(props: INewTeeSheetTabsDivisionProps) {
  const { t } = useTranslation();
  const { facilityStore, teeSheetStore } = useAppSelector(store => store);
  const cartWaiverSignatureRef = useRef<SignatureCanvas>(null);
  const {
    divisionRef,
    divisionWidth,
    useViewportBreakpoints,
    mobileSizedDivision,
    compactTabletSizedDivision,
    showTabletBookingNoteIcon,
    tabletBookingParticipantLayout,
    slotWrapSizedDivision,
  } = useDivisionBreakpoints(props.navigationKey, {
    useViewportBreakpoints: true,
  });
  const windowSize = useWindowSize();
  const dispatch = useAppDispatch();

  const { cancelToken, cancelRequest } = useCancelToken();
  const [highPriorityNotes, setHighPriorityNote] = useState<IHighPriorityNoteState>({
    notes: [],
    loading: false,
  });

  const { state: powerCartModal, updateModal: updatePowerCartModal, closeModal: closePowerCartModal } = useModal<IPowerCartModal>({
    selectedTeeTime: null, powerCarts: null, selectedPowerCarts: [], highPriorityNotes: [], teeOffTime: "", turnTime: "", finishTime: "", bookingNotes: [], signWaiverPage: false, waiverParticipant: null, agreeToWaiver: false, signatureData: null, signatureDate: null,
  });

  useEffect(() => {
    const source = axios.CancelToken.source();
    if (powerCartModal?.isOpen) {
      const selectedPowerCarts = powerCartModal?.selectedTeeTime?.slots.map(slot => ({
        power_cart_id: slot?.power_cart_id,
        participant_id: slot?.booking_participant_id,
        seat_number: slot?.seat_number,
        power_cart_number: slot?.power_cart_number,
        check_in_status: slot?.check_in_status,
        original_check_in_status: slot?.check_in_status,
      }));
      const teeOffTime = powerCartModal?.selectedTeeTime?.slots?.find(
        slot => slot?.tee_time_booking_participant_tee_off_time,
      );
      const turnTime = powerCartModal?.selectedTeeTime?.slots?.find(
        slot => slot?.tee_time_booking_participant_turn_time,
      );
      const finishTime = powerCartModal?.selectedTeeTime?.slots?.find(
        slot => slot?.tee_time_booking_participant_finish_time,
      );
      updatePowerCartModal({
        selectedPowerCarts,
        teeOffTime: teeOffTime ? teeOffTime?.tee_time_booking_participant_tee_off_time : "",
        turnTime: turnTime ? turnTime?.tee_time_booking_participant_turn_time : "",
        finishTime: finishTime ? finishTime?.tee_time_booking_participant_finish_time : "",
      });

      if (facilityStore?.teeSheetSettings?.use_cart_inventory) {
        void loadPowerCarts(source.token);
      }
      void loadHighPriorityNotes(source.token);
    }

    return () => source.cancel();
  }, [powerCartModal?.isOpen]);

  async function loadPowerCarts(cancelToken: CancelToken) {
    const powerCartRes = await GetPowerCarts(null, false, cancelToken);

    if (powerCartRes?.status !== StatusCode.OK) {
      if (cancelToken && cancelToken?.reason) {
        return;
      }
      updatePowerCartModal({ powerCarts: [] });
      dispatch(showError(t("Error getting power cart inventory")));
      return;
    }

    const carts = powerCartRes?.data;

    const filteredCarts = carts?.filter(
      cart =>
        cart.status === "available" ||
        (cart.status === "occupied" &&
          powerCartModal?.selectedTeeTime?.slots.find(slot => slot?.power_cart_id === cart.id)),
    );

    updatePowerCartModal({ powerCarts: filteredCarts });
  }

  async function loadHighPriorityNotes(cancelToken: CancelToken) {
    const validSlots = powerCartModal?.selectedTeeTime?.slots?.filter(slot => slot?.customer_id && !slot?.guest);
    //Get all non guests' high priority notes
    if (validSlots?.length > 0) {
      const notesRes = await Promise.all(
        validSlots?.map(
          async slot =>
            await GetCustomerNotes({ customer_id: slot?.customer_id, high_priority: true }, false, cancelToken),
        ),
      );
      if (notesRes?.some(res => res?.status !== StatusCode.OK)) {
        if (cancelToken && cancelToken?.reason) {
          return;
        }
        dispatch(showError(t("Error getting high priority notes")));
      }
      const validResponses = notesRes?.filter(res => res?.status === StatusCode.OK && res?.data?.length > 0);
      //Notes found, set in state
      if (validResponses?.length > 0) {
        const allNotes = validResponses?.reduce((combinedNotes, note) => {
          return combinedNotes?.concat(note?.data);
        }, [] as Array<TCustomerNote>);
        void updatePowerCartModal({ highPriorityNotes: allNotes });
      }
    }
  }

  function handlePaceUpdated(result: IPaceUpdateResult) {
    if (!powerCartModal?.selectedTeeTime) {
      return;
    }

    let updatedTeeTime = { ...powerCartModal.selectedTeeTime };
    let updatedSlots = [...updatedTeeTime.slots];

    result.participants.forEach(participant => {
      updatedSlots = updatedSlots.map(slot => {
        if (slot?.booking_participant_id === participant.id) {
          return {
            ...slot,
            tee_time_booking_participant_tee_off_time: participant.tee_off_time,
            tee_time_booking_participant_turn_time: participant.turn_time,
            tee_time_booking_participant_finish_time: participant.finish_time,
          };
        }
        return slot;
      });
    });

    updatedTeeTime = { ...updatedTeeTime, slots: updatedSlots };
    const updatedTeeTimes = [...props.sortedTeeTimes]?.map(teetime =>
      teetime?.slots[0]?.tee_time_id === updatedTeeTime?.slots[0]?.tee_time_id ? updatedTeeTime : teetime,
    );
    const updatedGroupedTeeTimes = [...props.groupedTeeTimes]?.map(teetime => {
      if (teetime?.start_time === updatedTeeTime?.slots[0]?.start_time) {
        const teetimeSlotsUpdated = teetime?.slots?.map(slotGroup => {
          return slotGroup?.map(slot => {
            const foundSlot = updatedSlots?.find(
              updatedSlot => updatedSlot?.booking_participant_id === slot?.booking_participant_id,
            );
            if (foundSlot) {
              return foundSlot;
            }
            return slot;
          });
        });
        return { ...teetime, slots: teetimeSlotsUpdated };
      }
      return teetime;
    });

    void props.updateMainState({ sortedTeeTimes: updatedTeeTimes, groupedTeeTimes: updatedGroupedTeeTimes });
    void updatePowerCartModal({
      selectedTeeTime: updatedTeeTime,
      teeOffTime: result.teeOffTime,
      turnTime: result.turnTime,
      finishTime: result.finishTime,
    });
  }

  const renderBookingParticipantIcons = (
    slot: ITeeTimeSlotNew,
    options?: { includeHoles?: boolean; hideCheckInStatusIcons?: boolean },
  ) => {
    const includeHoles = options?.includeHoles !== false;
    const hideCheckInStatusIcons = options?.hideCheckInStatusIcons === true;
    const highlight =
      facilityStore.teeSheetSettings.highlight_new_bookings &&
      moment
        .utc(slot.tee_time_bookings_completed_at)
        .local()
        .isSameOrAfter(moment().subtract({ hours: facilityStore?.teeSheetSettings.highlight_new_bookings_window })) &&
      moment.utc(slot.tee_time_bookings_completed_at).local().isSameOrBefore(moment()) &&
      slot.check_in_status === "unchecked";

    const overPace = isSlotOverPace(slot, facilityStore?.facility?.holes ?? 18, facilityStore?.teeSheetSettings);

    return (
      <>
        {slot.check_in_status === "arrived" && (
          <FontAwesomeIcon icon={faLocationCheck} className="booking-participant_icon" />
        )}

        {highlight && !overPace ? (
          <Badge size="small" type="warning">
            {t("New")}
          </Badge>
        ) : null}

        {!hideCheckInStatusIcons &&
          slot.check_in_status !== "checked" &&
          slot?.check_in_status !== "arrived" &&
          !slot.no_show_type &&
          !highlight && <FontAwesomeIcon icon={faCircle} className="booking-participant_icon" />}

        {slot.turn === 1 && <FontAwesomeIcon icon={faRepeatAlt} className="booking-participant_icon" />}

        {slot.order_financial_status === "paid" && (
          <FontAwesomeIcon icon={faUsdCircle} className="booking-participant_icon" />
        )}

      {slot?.tee_time_booking_participant_finish_time ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="finish-time-tooltip" className="tee_off_tooltip">
              {t("Finish time recorded at")}{" "}
              {moment
                .utc(slot.tee_time_booking_participant_finish_time, "YYYY-MM-DD HH:mm:ss")
                .local()
                .format("LT")}
            </Tooltip>
          }
        >
          <FontAwesomeIcon icon={faFlag} className="booking-participant_icon" />
        </OverlayTrigger>
      ) : slot?.tee_time_booking_participant_turn_time ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="turn-time-tooltip" className="tee_off_tooltip">
              {t("Turn time recorded at")}{" "}
              {moment
                .utc(slot.tee_time_booking_participant_turn_time, "YYYY-MM-DD HH:mm:ss")
                .local()
                .format("LT")}
            </Tooltip>
          }
        >
          <FontAwesomeIcon icon={faArrowUTurnUpRight} className="booking-participant_icon" />
        </OverlayTrigger>
      ) : slot?.tee_time_booking_participant_tee_off_time ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tee-off-time-tooltip" className="tee_off_tooltip">
              {t("Tee off recorded at")}{" "}
              {moment
                .utc(slot.tee_time_booking_participant_tee_off_time, "YYYY-MM-DD HH:mm:ss")
                .local()
                .format("LT")}
            </Tooltip>
          }
        >
          <FontAwesomeIcon icon={faPersonGolfing} className="booking-participant_icon" />
        </OverlayTrigger>
      ) : (
        !hideCheckInStatusIcons &&
        slot.check_in_status === "checked" && (
          <FontAwesomeIcon icon={faCheckCircle} className="booking-participant_icon" />
        )
      )}

        {slot.no_show_type && slot.no_show_type !== "weather" && (
          <FontAwesomeIcon icon={faBan} className="booking-participant_icon" />
        )}

        {slot.no_show_type === "weather" && (
          <FontAwesomeIcon icon={faThunderstorm} className="booking-participant_icon" />
        )}

        {!mobileSizedDivision && includeHoles && (
          <div className="booking-participant-holes-large">{slot.tee_time_bookings_holes}</div>
        )}

        {overPace ? <FontAwesomeIcon icon={faHourglassClock} className="booking-participant_icon" /> : null}
      </>
    );
  };

  const renderBookingCategoryIcons = (teeTimeId: number) => {
    if (!props.teetimeBookingCategories) {
      return;
    }

    const bookingCategories = props.teetimeBookingCategories[teeTimeId];

    if (!bookingCategories) {
      return;
    }

    return (
      <div className="booking-category-icons">
        {bookingCategories?.map((category: ITeeTimeBookingCategory, index: number) => {
          const categoryLabel = category?.title[0]?.toLocaleLowerCase();
          return (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id={`category-${category.title}`}>{category.title}</Tooltip>}
              key={index}
            >
              <FontAwesomeIcon
                icon={["far", `circle-${categoryLabel}` as IconName]}
                className="booking-category-icon"
              />
            </OverlayTrigger>
          );
        })}
      </div>
    );
  };

  const renderPromotionIcon = (slot: ITeeTimeSlotNew) => {
    if (!slot?.promotion_type || slot?.promotion_value == null) {
      return null;
    }

    const discount =
      slot.promotion_type === "percent" ? `${slot.promotion_value}% off` : `$${slot.promotion_value} off`;

    return (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`promotion-${slot.tee_time_id}`}>
            <div>{slot.promotion_label || t("Promotion")}</div>
            <div>{t("{{discount}} online pricing", { discount })}</div>
          </Tooltip>
        }
      >
        <FontAwesomeIcon className="tee-time-promotion-icon" icon={faTag} />
      </OverlayTrigger>
    );
  };

  function convertStartTimePeriod(startTime: string) {
    const tempHours = startTime?.split(":");
    const hours = Number(tempHours?.[0]);

    if (hours == null || isNaN(hours)) {
      return "";
    }

    if (hours < 12) {
      return " AM";
    } else {
      return " PM";
    }
  }

  function findMatchingGroupedTeeTime(
    teetime: ITeeTimeTabNew,
    groupedTeeTimes: ITeeTimeDraggable[],
  ): ITeeTimeDraggable {
    return groupedTeeTimes?.find(
      groupedTeeTime => groupedTeeTime.slots[0][0].tee_time_id === teetime.slots[0].tee_time_id,
    );
  }

  function tournamentName(id: number) {
    const tournament = props.teeSheetTournaments?.find(tournament => tournament.id === id);

    return tournament !== undefined ? tournament.name : t("Tournament");
  }

  function leagueName(id: number) {
    const league = props.teeSheetLeagues?.find(league => league.id === id);

    return league !== undefined ? league.name : t("League");
  }

  function tournamentNote(id: number) {
    const tournament = props.teeSheetTournaments?.find(tournament => tournament.id === id);

    return tournament !== undefined ? tournament?.tee_sheet_note : "";
  }

  function getDivisionCode(teeTimeSlot: ITeeTimeSlotNew) {
    const division = props.allDivisions?.find((division: IDivision) => division.id === teeTimeSlot?.division_id);
    const turnDivision = props?.allDivisions?.find(
      (division: IDivision) => division.id === teeTimeSlot?.turn_division_id,
    );

    if (division) {
      if (facilityStore.teeSheetSettings.display_turn_division_code) {
        const showsTurn =
          teeTimeSlot.turn_tee_time_id != null &&
          turnDivision?.code != null &&
          !isTurnBlockedForEighteenHoles(teeTimeSlot.turn_tee_time_blocked_type, teeTimeSlot.blocked_type);
        return division.code + (showsTurn ? ` - ${turnDivision.code}` : "");
      } else {
        return division.code;
      }
    } else {
      return "";
    }
  }

  function findCustomerTypeBackground(slot: ITeeTimeSlotNew) {
    let color = "#FFFFFF";

    if (slot.turn) {
      color = "#e7e7e7";
    } else if (slot.no_show_type == "weather") {
      color = "#fcbf49";
    } else if (slot.no_show_type) {
      color = "#d62828";
    } else if (slot.check_in_status === "checked") {
      color = "#82d195";
    } else if (slot.customer_id) {
      color = slot.customer_type_color;
    }

    return color;
  }

  const isTodayView = formatDate(teeSheetStore.selectedDate as Date) === formatDate(new Date());

  useTeeSheetNavigationAutoScroll(
    props.navigationKey,
    props.sortedTeeTimes,
    sorted => {
      if (!isTodayView) {
        return { type: "clear" };
      }
      const targetTeeTimeId = findTeeTimeIdClosestToLookbackAnchor(sorted);
      if (targetTeeTimeId == null) {
        return { type: "clear" };
      }
      return { type: "scroll", teeTimeId: targetTeeTimeId, block: "start" };
    },
    divisionRef,
  );

  // Get hovered customer's high priority note
  async function getHighPriorityNote(customerId: number) {
    void cancelRequest();
    setHighPriorityNote({ loading: true, notes: [] });
    const noteCancelToken = cancelToken();
    const res = await GetCustomerNotes({ customer_id: customerId, high_priority: true }, false, noteCancelToken);
    if (res?.status !== StatusCode.OK) {
      setHighPriorityNote({ loading: false, notes: [] });
      if (noteCancelToken && noteCancelToken?.reason) {
        return;
      }
      dispatch(showError(t("Error getting high priority note")));
      return;
    }

    setHighPriorityNote(prev => ({ ...prev, loading: false, notes: res?.data ?? [] }));
  }

  // Close high priority note tooltip
  function cancelGetHighPriorityNote() {
    void cancelRequest();
    setHighPriorityNote({ loading: false, notes: [] });
  }

  function changeSeatNumber(
    seatNumber: number,
    participantId: number,
    cartId: number,
    status: string,
    cartNumber: number,
  ) {
    const sameCartPassengers = powerCartModal?.selectedPowerCarts?.filter(cart =>
      facilityStore.teeSheetSettings?.use_cart_inventory
        ? cart?.power_cart_id === cartId
        : cart?.power_cart_number === cartNumber,
    );
    // More than one passenger assigned a cart, switch their seat numbers
    if (sameCartPassengers?.length > 1) {
      //Swap passengers' seat numbers
      const updatedSameCartPassengers = sameCartPassengers?.map(cart => {
        if (cart?.participant_id === participantId) {
          return { ...cart, seat_number: seatNumber };
        } else {
          return { ...cart, seat_number: seatNumber === 1 ? 2 : 1 };
        }
      });
      const powerCartList = powerCartModal?.selectedPowerCarts?.map(cart => {
        const foundCart = updatedSameCartPassengers?.find(
          foundCart => foundCart?.participant_id === cart?.participant_id,
        );
        if (foundCart) {
          return foundCart;
        } else {
          return cart;
        }
      });
      void updatePowerCartModal({ selectedPowerCarts: powerCartList });
    } else {
      const powerCartList = !powerCartModal?.selectedPowerCarts?.some(cart => cart?.participant_id === participantId)
        ? [
            ...powerCartModal.selectedPowerCarts,
            {
              power_cart_id: cartId,
              participant_id: participantId,
              seat_number: seatNumber,
              power_cart_number: null,
              check_in_status: status,
              original_check_in_status: status,
            },
          ]
        : powerCartModal?.selectedPowerCarts.map(powerCart =>
            participantId === powerCart?.participant_id ? { ...powerCart, seat_number: seatNumber } : powerCart,
          );
      void updatePowerCartModal({ selectedPowerCarts: powerCartList });
    }
  }

  function handleCartIdChange(cartId: number, participant_id: number, status: string) {
    const foundCart = powerCartModal?.selectedPowerCarts?.find(powerCart => powerCart?.power_cart_id === cartId);
    const seatNumber = foundCart ? (foundCart?.seat_number <= 1 ? 2 : 1) : 1;

    const powerCartList = !powerCartModal?.selectedPowerCarts?.some(cart => cart?.participant_id === participant_id)
      ? [
          ...powerCartModal.selectedPowerCarts,
          {
            power_cart_id: cartId,
            participant_id: participant_id,
            seat_number: seatNumber,
            power_cart_number: null,
            check_in_status: status,
            original_check_in_status: status,
          },
        ]
      : powerCartModal?.selectedPowerCarts.map(powerCart =>
          participant_id === powerCart?.participant_id
            ? { ...powerCart, power_cart_id: cartId, seat_number: seatNumber, power_cart_number: null }
            : powerCart,
        );

    updatePowerCartModal({ selectedPowerCarts: powerCartList });
  }

  function removePowerCartId(cartId: number, participant_id: number, status: string) {
    const seatNumber = 1;

    const powerCartList = !powerCartModal?.selectedPowerCarts?.some(cart => cart?.participant_id === participant_id)
      ? [
          ...powerCartModal.selectedPowerCarts,
          {
            power_cart_id: null,
            participant_id: participant_id,
            seat_number: null,
            power_cart_number: null,
            check_in_status: status,
            original_check_in_status: status,
          },
        ]
      : powerCartModal?.selectedPowerCarts.map(powerCart =>
          participant_id === powerCart?.participant_id
            ? { ...powerCart, power_cart_id: null, seat_number: null, power_cart_number: null }
            : participant_id !== powerCart?.participant_id && powerCart?.power_cart_id === cartId
            ? { ...powerCart, seat_number: seatNumber }
            : powerCart,
        );

    updatePowerCartModal({ selectedPowerCarts: powerCartList });
  }

  function handleCartNumberChange(cartNumber: number, participant_id: number, status: string) {
    const foundCart = powerCartModal?.selectedPowerCarts?.find(
      powerCart => powerCart?.power_cart_number === cartNumber,
    );
    const seatNumber = foundCart ? (foundCart?.seat_number <= 1 ? 2 : 1) : 1;

    const powerCartList = !powerCartModal?.selectedPowerCarts.some(cart => cart.participant_id === participant_id)
      ? [
          ...powerCartModal.selectedPowerCarts,
          {
            power_cart_id: null,
            participant_id: participant_id,
            seat_number: seatNumber,
            power_cart_number: cartNumber ? cartNumber : null,
            check_in_status: status,
            original_check_in_status: status,
          },
        ]
      : powerCartModal?.selectedPowerCarts.map(powerCart =>
          participant_id === powerCart.participant_id
            ? {
                ...powerCart,
                power_cart_id: null,
                seat_number: cartNumber ? seatNumber : null,
                power_cart_number: cartNumber ? cartNumber : null,
              }
            : powerCart,
        );

    updatePowerCartModal({ selectedPowerCarts: powerCartList });
  }

  async function savePowerCartNumbers() {
    const filtered = powerCartModal?.selectedPowerCarts.filter(
      cart =>
        ((cart?.power_cart_id != null || cart?.power_cart_number != null) && cart?.seat_number != null) ||
        cart?.check_in_status === "arrived" ||
        cart?.check_in_status === "unchecked",
    );

    dispatch(enqueue());
    if (filtered?.length > 0) {
      const res = await Promise.all(
        filtered?.map(
          async cart =>
            await PutBookingParticipant(
              {
                id: cart.participant_id,
                power_cart_id: cart.power_cart_id,
                seat_number: cart.seat_number,
                power_cart_number: cart.power_cart_number,
                check_in_status:
                  cart?.check_in_status === "arrived" ||
                  cart?.check_in_status === "unchecked" ||
                  cart?.check_in_status === "checked"
                    ? cart?.check_in_status
                    : undefined,
              },
              false,
            ),
        ),
      );

      if (res.some(res => res.status !== StatusCode.OK)) {
        dispatch(showError(t("Error saving participants")));
      } else {
        await props.loadTeeSheet();
        dispatch(showSuccess(t("Succesfully updated participants")));
      }
    }
    dispatch(dequeue());

    void closePowerCartModal();
  }

  function updateParticipantStatus(arrived: boolean, id: number) {
    let updatedSelectedCarts = [...powerCartModal.selectedPowerCarts];
    updatedSelectedCarts = updatedSelectedCarts?.map(cart =>
      cart?.participant_id === id
        ? {
            ...cart,
            check_in_status: arrived
              ? cart?.original_check_in_status === "checked"
                ? "checked"
                : "arrived"
              : "unchecked",
          }
        : cart,
    );
    void updatePowerCartModal({ selectedPowerCarts: updatedSelectedCarts });
  }

  function isPartOfGroup(prevTeeTime: ITeeTimeTabNew, nextTeeTime: ITeeTimeTabNew, teetime: ITeeTimeTabNew): boolean {
    const prevBookingId = prevTeeTime?.slots?.find(
      slot => slot?.tee_time_bookings_group_id,
    )?.tee_time_bookings_group_id;
    const nextBookingId = nextTeeTime?.slots?.find(
      slot => slot?.tee_time_bookings_group_id,
    )?.tee_time_bookings_group_id;
    const currBookingId = teetime?.slots?.find(slot => slot?.tee_time_bookings_group_id)?.tee_time_bookings_group_id;
    return currBookingId && (prevBookingId === currBookingId || currBookingId === nextBookingId);
  }

  function bookingGroupsHeader(nextTeeTime: ITeeTimeTabNew, teetime: ITeeTimeTabNew) {
    const nextBookingId = nextTeeTime?.slots?.find(
      slot => slot?.tee_time_bookings_group_id,
    )?.tee_time_bookings_group_id;
    const currBookingId = teetime?.slots?.find(slot => slot?.tee_time_bookings_group_id)?.tee_time_bookings_group_id;
    return nextBookingId == currBookingId;
  }

  function isLastTeeTimeInGroup(
    prevTeeTime: ITeeTimeTabNew,
    nextTeeTime: ITeeTimeTabNew,
    currentTeeTime: ITeeTimeTabNew,
  ) {
    const prevTeetime = prevTeeTime?.slots?.find(slot => slot?.tee_time_bookings_group_id)?.tee_time_bookings_group_id;
    const nextTeetime = nextTeeTime?.slots?.find(slot => slot?.tee_time_bookings_group_id)?.tee_time_bookings_group_id;
    const currentGroupId = currentTeeTime?.slots?.find(
      slot => slot?.tee_time_bookings_group_id,
    )?.tee_time_bookings_group_id;
    return currentGroupId && prevTeetime === currentGroupId && nextTeetime !== currentGroupId;
  }

  function isFirstTeeTimeInGroup(teetime: ITeeTimeTabNew, teetimeIndex: number): boolean {
    const groupId = teetime.slots[0]?.tee_time_bookings_group_id;

    if (!groupId) {
      return false;
    }

    // Check if previous tee time has the same group ID
    const prevTeetime = props.sortedTeeTimes[teetimeIndex - 1];
    return prevTeetime === undefined || prevTeetime.slots[0]?.tee_time_bookings_group_id !== groupId;
  }

  async function openPowerCartModal(teetime: ITeeTimeNew) {
    const hasNotes = teetime?.slots?.some(slot => slot?.has_notes);
    const bookingIds = teetime?.slots
      ?.filter(slot => slot?.tee_time_booking_id)
      ?.map(slot => slot?.tee_time_booking_id);
    const uniqueBookingIds = [...new Set(bookingIds)];

    let notes: Array<IBookingNote> = [];
    if (hasNotes && uniqueBookingIds && uniqueBookingIds?.length > 0) {
      dispatch(enqueue());
      const notesRes = await Promise.all(
        uniqueBookingIds?.map(bookingId => GetBookingNotes({ tee_time_booking_id: bookingId }, false)),
      );
      dispatch(dequeue());
      if (notesRes?.some(res => res?.status !== StatusCode.OK)) {
        dispatch(showError(t("Error getting booking notes")));
        notes = [];
      } else {
        const bookingNotes = notesRes?.map(noteRes =>
          noteRes?.status === StatusCode.OK ? (noteRes?.data as Array<IBookingNote>) : [],
        );
        notes = [].concat(...bookingNotes);
      }
    }
    updatePowerCartModal({ isOpen: true, selectedTeeTime: teetime, bookingNotes: notes });
  }

  function getBookingNotes(bookingId: number) {
    if (powerCartModal?.bookingNotes?.length > 0) {
      return powerCartModal?.bookingNotes?.filter(note => note?.tee_time_booking_id === bookingId);
    } else {
      return [];
    }
  }

  async function confirmSignWaiver() {
    if (cartWaiverSignatureRef?.current?.isEmpty()) {
      dispatch(showError(t("Signature required")));
      return;
    }

    const signatureStrokes = cartWaiverSignatureRef?.current?.toDataURL();
    const res = await PutBookingParticipant({ id: powerCartModal?.waiverParticipant?.booking_participant_id, cart_waiver_signature: signatureStrokes }, true);
    if (res?.status !== StatusCode.OK) {
      dispatch(showError(typeof res?.data === "string" ? res?.data : t("Error signing waiver")));
      return;
    }
    dispatch(showSuccess(t("Successfully signed waiver")));
    await savePowerCartNumbers();
  }

  function renderTeeTimeDetailsModal() {
    return (
      powerCartModal?.signWaiverPage ? (
        <div>
          <Card title={t("View Liabilities and Agreements")} collapsable defaultCollapsed>
            <Card.Section title=" ">
              <Markdown markdownText={facilityStore?.teeSheetSettings?.cart_waiver_content} />
            </Card.Section>
          </Card>
          <br />
          <FormLayout>
            <FormLayout.Group>
              <Checkbox disabled={!!powerCartModal?.signatureData} checked={powerCartModal?.agreeToWaiver} onChange={e => updatePowerCartModal({ agreeToWaiver: e.target.checked })} size="medium" label={t("I have read and agree to the cart waiver")} />
            </FormLayout.Group>
          </FormLayout>
          <Divider />
          {powerCartModal?.signatureData ? (
            <DataTable columns={[{ label: t("Signed By") }, { label: t("Date") }, { label: t("Signature") }]}>
              <tr>
                <td>
                  <div className="flex flex-col items-start">
                    <p className="tee-times-group-pace-primary-text">{powerCartModal?.waiverParticipant?.full_name}</p>
                    <p className="tee-times-group-pace-secondary-text">{powerCartModal?.waiverParticipant?.customer_type}</p>
                  </div>
                </td>
                <td>
                  {moment.utc(powerCartModal?.signatureDate, "YYYY-MM-DD HH:mm:mm")?.local()?.format("ll")}
                </td>
                <td>
                  <SignaturePreview
                    base64string={powerCartModal?.signatureData}
                    height={32}
                  />
                </td>
              </tr>
            </DataTable>
          ) : (
            <SignaturePad
              ref={cartWaiverSignatureRef}
              label={"Signature for " + powerCartModal?.waiverParticipant?.full_name}
              helpText={t("Sign using your finger or stylus")}
              onClear={() => cartWaiverSignatureRef?.current?.clear()}
              disabled={!powerCartModal?.agreeToWaiver}
            />
          )}
        </div>
      ) : (
        <div>
          <PaceTracker
            embedded
            teeOffTime={powerCartModal?.teeOffTime ?? ""}
            turnTime={powerCartModal?.turnTime ?? ""}
            finishTime={powerCartModal?.finishTime ?? ""}
            bookingParticipantIds={
              powerCartModal?.selectedTeeTime?.slots
                ?.filter(slot => slot?.booking_participant_id)
                ?.map(slot => slot.booking_participant_id) ?? []
            }
            onPaceUpdated={handlePaceUpdated}
          />
          <div>
            <DataTable
              columns={[{ label: t("Player") }, { label: t("Power Cart") }, { label: t("Arrival Status") }]}
              overflow
            >
              {powerCartModal?.selectedTeeTime?.slots
                .filter(slot => slot.booking_participant_id)
                .map((slot, index, slots) => {
                  const foundParticipant = powerCartModal?.selectedPowerCarts?.find(
                    cart => cart?.participant_id === slot?.booking_participant_id,
                  );
                  const highPriorityNotes = powerCartModal?.highPriorityNotes?.filter(
                    note => note?.customer_id === slot?.customer_id,
                  );
                  const currentBookingId = slot?.tee_time_booking_id;
                  let differentBooking = index === 0 ? true : false;
                  if (slots[index - 1] && slots[index - 1]?.tee_time_booking_id !== currentBookingId) {
                    differentBooking = true;
                  }
                  let bookingNotes: Array<IBookingNote> = [];
                  if (differentBooking) {
                    bookingNotes = getBookingNotes(slot?.tee_time_booking_id);
                  }
                  const bookingNotesExist = differentBooking && bookingNotes?.length > 0;
                  const hideBorderBottom =
                    (powerCartModal?.highPriorityNotes?.length > 0 && !slot?.guest && highPriorityNotes?.length > 0) ||
                    bookingNotesExist;

                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td style={{ borderBottom: hideBorderBottom ? "0" : undefined }}>
                          <div className="flex items-center gap-2">
                            <Avatar size="medium" />
                            <div className="flex flex-col">
                              <p className="tee-times-group-pace-primary-text flex items-center gap-2">
                                {slot?.customer_first_name} {slot?.customer_last_name}{" "}
                                {slot?.riding ? (
                                  <img className="w-4 h-4" src="../../../public/images/powercart2-01.svg" alt="Riding" />
                                ) : (
                                  <FontAwesomeIcon icon={faPersonWalking} />
                                )}
                              </p>
                              <p className="tee-times-group-pace-secondary-text">
                                {slot?.guest
                                  ? t("Guest")
                                  : `${slot?.customer_type_title} ${slot?.customer_type_subtitle ? ` - ${slot?.customer_type_subtitle}` : ""
                                  }`}
                              </p>
                            </div>
                          </div>
                        </td>
                        <td style={{ borderBottom: hideBorderBottom ? "0" : undefined }}>
                          <FormLayout>
                            <FormLayout.Group>
                              {facilityStore.teeSheetSettings?.use_cart_inventory ? (
                                !powerCartModal?.powerCarts ? (
                                  <div style={{ width: "30px", height: "30px" }}>
                                    <Spin />
                                  </div>
                                ) : foundParticipant?.power_cart_id ? (
                                  <GolferCard
                                    name={
                                      powerCartModal?.powerCarts?.find(
                                        cart => cart?.id === foundParticipant?.power_cart_id,
                                      )?.name
                                    }
                                    closable
                                    removeGolfer={() =>
                                      removePowerCartId(
                                        foundParticipant?.power_cart_id,
                                        slot?.booking_participant_id,
                                        slot?.check_in_status,
                                      )
                                    }
                                  />
                                ) : (
                                  <SelectNew
                                    // label={t("Power Cart")}
                                    id={"power-cart-select"}
                                    options={powerCartModal?.powerCarts
                                      ?.filter(availableCart => {
                                        return (
                                          powerCartModal?.selectedPowerCarts?.filter(
                                            selectedCarts => selectedCarts.power_cart_id === availableCart.id,
                                          ).length < MAX_SEATS_PER_CART ||
                                          powerCartModal?.selectedPowerCarts?.some(
                                            selectedCarts =>
                                              selectedCarts.power_cart_id === availableCart.id &&
                                              selectedCarts.participant_id === slot?.booking_participant_id,
                                          )
                                        );
                                      })
                                      .map(cart => ({
                                        label: cart.name,
                                        id: cart.id,
                                      }))}
                                    onChange={(value: number) =>
                                      handleCartIdChange(value, slot?.booking_participant_id, slot?.check_in_status)
                                    }
                                    value={foundParticipant?.power_cart_id ?? ""}
                                    searchable={0.5}
                                    isLoading={!powerCartModal?.powerCarts}
                                    searchInputType={windowSize.width <= SMALL_DESKTOP_WIDTH ? "number" : "text"}
                                    mobileSlideupSearch={windowSize.width <= SMALL_DESKTOP_WIDTH}
                                    placeholder={t("Search...")}
                                    disabled={!slot?.riding}
                                  />
                                )
                              ) : (
                                <Input
                                  // label={t("Cart Number")}
                                  value={foundParticipant?.power_cart_number ? foundParticipant?.power_cart_number : ""}
                                  type={"number"}
                                  placeholder={t("Cart Number")}
                                  onChange={e =>
                                    handleCartNumberChange(
                                      Number(e.target.value),
                                      slot?.booking_participant_id,
                                      slot?.check_in_status,
                                    )
                                  }
                                  disabled={!slot?.riding}
                                />
                              )}
                            <SelectNew
                              label={t("Seat")}
                              id={"seat-select"}
                              options={[
                                { id: 1, label: t("Driver") },
                                { id: 2, label: t("Passenger") },
                              ]}
                              onChange={(value: number) =>
                                changeSeatNumber(
                                  value,
                                  slot?.booking_participant_id,
                                  foundParticipant?.power_cart_id,
                                  slot?.check_in_status,
                                  foundParticipant?.power_cart_number,
                                )
                              }
                              value={foundParticipant?.seat_number ?? ""}
                              disabled={
                                !slot?.riding
                                  ? true
                                  : facilityStore.teeSheetSettings?.use_cart_inventory
                                  ? !foundParticipant?.power_cart_id
                                  : !foundParticipant?.power_cart_number
                              }
                            />
                          </FormLayout.Group>
                        </FormLayout>
                      </td>
                      <td style={{ borderBottom: hideBorderBottom ? "0" : undefined }}>
                        <ButtonGroup
                          buttons={[
                            { label: <FontAwesomeIcon icon={faCheck} />, key: "arrived" },
                            { label: <FontAwesomeIcon icon={faXmark} />, key: "not-arrived" },
                          ]}
                          disabled={foundParticipant?.check_in_status === "checked"}
                          startKey={
                            foundParticipant?.check_in_status === "arrived" ||
                            foundParticipant?.check_in_status === "checked"
                              ? "arrived"
                              : "not-arrived"
                          }
                          onButtonClick={key =>
                            updateParticipantStatus(key === "arrived" ? true : false, slot?.booking_participant_id)
                          }
                        />
                      </td>
                    </tr>

                    {powerCartModal?.highPriorityNotes?.length > 0 && !slot?.guest
                      ? highPriorityNotes?.map((note, noteIndex) => {
                          return (
                            <tr key={noteIndex}>
                              <td
                                colSpan={3}
                                style={{ paddingTop: "0", borderBottom: bookingNotesExist ? "0" : undefined }}
                              >
                                <div className="tee-times-group-pace-priority-note">
                                  <div>
                                    <Badge
                                      size="medium"
                                      type="error"
                                      className="tee-times-group-pace-priority-note-icon"
                                    >
                                      <FontAwesomeIcon icon={faCircleExclamation} />
                                    </Badge>
                                  </div>
                                  <div>
                                    <span>
                                      <b>{note?.author?.full_name}</b>
                                    </span>{" "}
                                    {t("posted: ")} {note?.content}
                                    {note?.created_at ? ` • ${moment(note.created_at).format("LLL")}` : ""}
                                  </div>{" "}
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      : null}

                    {bookingNotesExist
                      ? bookingNotes?.map((bookingNote, noteIndex, bookingNotes) => {
                          const removeBorderBottom = bookingNotes?.length > 0 && noteIndex + 1 < bookingNotes?.length;
                          return (
                            <tr key={noteIndex}>
                              <td
                                colSpan={3}
                                style={{ paddingTop: "0", borderBottom: removeBorderBottom ? "0" : undefined }}
                              >
                                <div className="tee-times-group-pace-priority-note">
                                  <div>
                                    <Badge
                                      size="medium"
                                      type="primary"
                                      className="tee-times-group-pace-priority-note-icon"
                                    >
                                      <FontAwesomeIcon icon={faUser} />
                                    </Badge>
                                  </div>
                                  <div>
                                    <span>
                                      <b>{bookingNote?.author?.full_name}</b>
                                    </span>{" "}
                                    {t("posted: ")} {bookingNote?.content}
                                    {bookingNote?.created_at ? ` • ${moment(bookingNote.created_at).format("LLL")}` : ""}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                        : null}
                    </React.Fragment>
                  );
                })}
            </DataTable>
          </div>
          <br />
          {powerCartModal?.selectedPowerCarts?.some(cart => cart?.seat_number === 1) ? (
            <Card>
              {powerCartModal?.selectedPowerCarts?.filter(cart => cart?.seat_number === 1)?.map((cart, index) => {
                const foundSlot = powerCartModal?.selectedTeeTime?.slots?.find(slot => slot?.booking_participant_id === cart?.participant_id);
                if (foundSlot?.cart_waiver_signature) {
                  return (
                    <Card.Section key={index}>
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                          <p className="text-semibold">{t("Cart Waiver ")} {index + 1} - </p>
                          <p className="text-semibold">{foundSlot?.customer_first_name} {foundSlot?.customer_last_name}</p>
                          <Badge size="medium" type="success">{t("Signed")}</Badge>
                        </div>
                        <div className="tee-times-group-pace-view-waiver" onClick={() => {
                          const signatureData = foundSlot?.cart_waiver_signature;
                          void updatePowerCartModal({ agreeToWaiver: true, signatureDate: foundSlot?.cart_waiver_signed_at, signatureData: signatureData, signWaiverPage: true, waiverParticipant: { booking_participant_id: foundSlot.booking_participant_id, full_name: `${foundSlot?.customer_first_name} ${foundSlot?.customer_last_name}`, customer_type: `${foundSlot?.customer_type_title} ${foundSlot?.customer_type_subtitle ? ` - ${foundSlot?.customer_type_subtitle}` : ""}` } });
                        }
                        }>
                          {t("View Waiver")} <FontAwesomeIcon icon={faChevronRight} />
                        </div>
                      </div>
                    </Card.Section>
                  );
                } else {
                  return (
                    <Card.Section key={index}>
                      <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                          <p className="text-semibold">{t("Cart Waiver ")} {index + 1} - </p>
                          <p className="text-semibold">{foundSlot?.customer_first_name} {foundSlot?.customer_last_name}</p>
                        </div>
                        <Button size="medium" type="primary" onClick={() => updatePowerCartModal({ signWaiverPage: true, waiverParticipant: { booking_participant_id: foundSlot.booking_participant_id, full_name: `${foundSlot?.customer_first_name} ${foundSlot?.customer_last_name}`, customer_type: `${foundSlot?.customer_type_title} ${foundSlot?.customer_type_subtitle ? ` - ${foundSlot?.customer_type_subtitle}` : ""}` } })}>
                          <FontAwesomeIcon icon={faPencilLine} className="mr-1" /> {t("Sign Waiver")}</Button>
                      </div>
                    </Card.Section>
                  );
                }

              })}
            </Card>
          ) : null}
        </div>
      )
    );
  }

  const sunsetLineTime = getSunsetLinePlacementTime(facilityStore.weather?.sunset);

  return (
    <div
      ref={divisionRef}
      className={classNames("tee-sheet-tabs-division", {
        [props.divisionClassName]: !!props.divisionClassName,
        "tee-sheet-tabs-division--viewport-breakpoints": useViewportBreakpoints,
        "tee-sheet-tabs-division--slot-wrap": slotWrapSizedDivision,
      })}
    >
      {props.sortedTeeTimes?.map((teetime, teetimeIndex: number, teetimes) => {
        const prevTeetime = teetimes[teetimeIndex - 1];
        const nextTeetime = teetimes[teetimeIndex + 1];

        return (
          <Fragment key={teetimeIndex}>
            {/* LEAGUE/TOURNAMENT/SHOTGUN HEADER */}
            {/* LEAGUE HEADER */}
            {teetime.slots[0].league_id > 0 &&
            (prevTeetime === undefined ||
              prevTeetime.slots[0].league_id === null ||
              prevTeetime.slots[0].league_id != teetime.slots[0].league_id) ? (
              <div className="tee-sheet-events-header text-white pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>
                      <FontAwesomeIcon className="mr-2" icon={faUsers} />
                      {props.teeSheetLeagues === undefined ? (
                        <span style={{ display: "inline-flex" }}>
                          <Spin />
                        </span>
                      ) : (
                        leagueName(teetime.slots[0].league_id)
                      )}
                    </div>
                    <div className="text-black"></div>
                  </div>
                </span>
              </div>
            ) : null}

            {/* TOURNAMENT HEADER */}
            {teetime.slots[0].tournament_id > 0 &&
            (prevTeetime === undefined ||
              prevTeetime.slots[0].tournament_id === null ||
              prevTeetime.slots[0].tournament_id != teetime.slots[0].tournament_id) ? (
              <div className="tee-sheet-events-header text-white pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>
                      <FontAwesomeIcon className="mr-2" icon={faTrophy} />
                      {props?.teeSheetTournaments === undefined ? (
                        <div style={{ display: "inline-flex" }}>
                          <Spin />
                        </div>
                      ) : (
                        tournamentName(teetime.slots[0].tournament_id)
                      )}
                    </div>
                    <div className="text-black"></div>
                  </div>
                </span>
                <p>
                  {tournamentNote(teetime.slots[0].tournament_id)
                    ? tournamentNote(teetime.slots[0].tournament_id).toLocaleLowerCase()
                    : ""}
                </p>
              </div>
            ) : null}

            {/* Group Bookings Header */}
            {isPartOfGroup(prevTeetime, nextTeetime, teetime) &&
            !teetime.slots[0].tournament_id &&
            !teetime.slots[0].league_id &&
            (prevTeetime === undefined ||
              (prevTeetime?.slots?.every(
                slot =>
                  !slot?.tee_time_bookings_group_id ||
                  teetime?.slots?.every(
                    currTeeTime => currTeeTime?.tee_time_bookings_group_id !== slot?.tee_time_bookings_group_id,
                  ),
              ) &&
                bookingGroupsHeader(nextTeetime, teetime))) ? (
              <div className="tee-sheet-group pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>
                      <FontAwesomeIcon className="mr-2" icon={faUserGroup} />
                      {teetime.slots[0]?.tee_time_bookings_group_name
                        ? teetime.slots[0]?.tee_time_bookings_group_name
                        : t("Group")}
                    </div>
                    <div className="text-black"></div>
                  </div>
                </span>
              </div>
            ) : null}

            {/* SHOTGUN HEADER */}
            {teetime.slots[0].blocked_type === "shotgun" &&
            teetime.slots[0].tournament_id === null &&
            teetime.slots[0].league_id === null &&
            (prevTeetime === undefined || prevTeetime.slots[0].blocked_type !== "shotgun") ? (
              <div className="background-primary text-white pl-4 pr-4 py-2 rounded-top">
                <span>
                  <div className="flex justify-between">
                    <div>{t("Shotgun")}</div>
                    <div className="text-black"></div>
                  </div>
                </span>
              </div>
            ) : null}

            {/* TEE TIME CONTAINER */}
            <div
              className={classNames("tee-time-new", {
                "pb-3.5 tee-sheet-events-body event-side-border":
                  teetime.slots[0].league_id > 0 ||
                  teetime.slots[0].tournament_id > 0 ||
                  isPartOfGroup(prevTeetime, nextTeetime, teetime),
                "pb-3.5 background-primary-light event-side-border":
                  teetime.slots[0].league_id === null &&
                  teetime.slots[0].tournament_id === null &&
                  teetime.slots[0].blocked_type === "shotgun",
                "pt-3.5":
                  (teetime.slots[0].league_id > 0 &&
                    (prevTeetime === undefined ||
                      prevTeetime.slots[0].league_id === null ||
                      prevTeetime.slots[0].league_id != teetime.slots[0].league_id)) ||
                  (teetime.slots[0].tournament_id > 0 &&
                    (prevTeetime === undefined ||
                      prevTeetime.slots[0].tournament_id === null ||
                      prevTeetime.slots[0].tournament_id != teetime.slots[0].tournament_id)) ||
                  (teetime.slots[0].blocked_type === "shotgun" &&
                    (prevTeetime === undefined || prevTeetime.slots[0].blocked_type !== "shotgun")) ||
                  (isFirstTeeTimeInGroup(teetime, teetimeIndex) && isPartOfGroup(prevTeetime, nextTeetime, teetime)),
                "rounded-bottom event-bottom-border":
                  (teetime.slots[0].league_id > 0 &&
                    (nextTeetime === undefined ||
                      nextTeetime.slots[0].league_id === null ||
                      nextTeetime.slots[0].league_id != teetime.slots[0].league_id)) ||
                  (teetime.slots[0].tournament_id > 0 &&
                    (nextTeetime === undefined ||
                      nextTeetime.slots[0].tournament_id === null ||
                      nextTeetime.slots[0].tournament_id != teetime.slots[0].tournament_id)) ||
                  (teetime.slots[0].blocked_type === "shotgun" &&
                    (nextTeetime === undefined || nextTeetime.slots[0].blocked_type !== "shotgun")) ||
                  (isLastTeeTimeInGroup(prevTeetime, nextTeetime, teetime) &&
                    !teetime.slots[0].tournament_id &&
                    !teetime.slots[0].league_id),
                "tee-time-new-spaced":
                  teetime.slots[0].league_id === null &&
                  !isPartOfGroup(prevTeetime, nextTeetime, teetime) &&
                  teetime.slots[0].tournament_id === null &&
                  teetime.slots[0].blocked_type !== "shotgun" &&
                  prevTeetime !== undefined,
              })}
              key={teetimeIndex}
              id={String(teetime.slots[0].tee_time_id)}
            >
              {/* SUNRISE MARKER */}
              {((teetimeIndex === 0 && facilityStore.weather?.sunrise < teetime?.start_time) ||
                (facilityStore.weather?.sunrise >= prevTeetime?.start_time &&
                  facilityStore.weather?.sunrise < teetime?.start_time)) && (
                <div className="flex items-center mb-3.5">
                  <div className="sun-time-line"></div>
                  <span className="sun-time-hour">
                    <FontAwesomeIcon icon={faSunrise} className="booking-participant_icon mt-1" />
                    {convertTime(facilityStore.weather?.sunrise)}
                  </span>
                  <div style={{ marginRight: "8px" }} className="sun-time-line"></div>
                </div>
              )}

              {/* HOUR MARKERS */}
              {teetimeIndex === 0 ||
              convertTime(teetime.start_time).split(":")[0] !== convertTime(prevTeetime.start_time).split(":")[0] ? (
                <div className="tee-time hour-block">
                  <p className="tee-time time tee-time hour">
                    {convertTime(teetime.start_time).split(":")[0] +
                      ":00 " +
                      convertTime(teetime.start_time).split(" ")[1]}
                  </p>
                  <div className="tee-time hour-line"></div>
                </div>
              ) : null}

              {/* TEE TIME */}
              <div className="tee-time_container">
                {/* TEE TIME START TIME */}
                <button className="tee-time-time cursor-pointer" onClick={() => {}}>
                  <p
                    className={
                      teetime.slots[0].tournament_id || teetime.slots[0].league_id
                        ? "tee-time-time-text-event"
                        : "tee-time-time-text"
                    }
                  >
                    {teetime.slots[0].blocked_type === "shotgun" ||
                    teetime.slots[0].blocked_type === "shotgun_crossover" ? (
                      <span>
                        {renderPromotionIcon(teetime.slots[0])}
                        <span>{teetime.slots[0].start_hole}</span>
                      </span>
                    ) : (
                      <span>
                        {renderPromotionIcon(teetime.slots[0])}
                        <span>{convertTime(teetime.start_time, true)}</span>
                        {!mobileSizedDivision && <span>{convertStartTimePeriod(teetime.start_time)}</span>}
                      </span>
                    )}
                  </p>
                </button>

                {/* DIVISION CODE */}
                {!mobileSizedDivision && (
                  <p
                    className="tee-time-division-code"
                    style={calculateDivisionColors(
                      props.allDivisions?.find((division: IDivision) => division.id === teetime.slots[0].division_id)
                        ?.color,
                    )}
                  >
                    {getDivisionCode(teetime.slots[0])}
                  </p>
                )}

                {facilityStore.teeSheetSettings?.validate_power_cart_count &&
                  teetime.power_cart_quantity != null &&
                  teetime.carts_available != null && (
                    <OverlayTrigger
                      placement="right"
                      show={teetime.power_cart_numbers?.length > 0 ? undefined : false}
                      overlay={
                        <Tooltip id={`teeTimePowerCartAvailability-${teetimeIndex}-${teetime.slots[0].division_id}`}>
                          {teetime.power_cart_numbers}
                        </Tooltip>
                      }
                    >
                      <div className="tee-time-power-cart-availability">
                        {`${teetime.power_cart_quantity}/${teetime.carts_available}`}
                      </div>
                    </OverlayTrigger>
                  )}

                {/* SLOTS */}
                <div className="tee-time-slots">
                  <span
                    className="row-container"
                    style={
                      {
                        "--tee-time-slot-columns": teetime.slots.length,
                      } as React.CSSProperties
                    }
                  >
                    {findMatchingGroupedTeeTime(teetime, props.groupedTeeTimes)?.slots?.map(
                      (slotGroup, groupIndex: number) => {
                        const slotId = slotGroup[0]?.tee_time_slot_id.toString();

                        return (
                          <div
                            className={classNames("tee-time-slots_container", {
                              "tee-time-slots_container-grouped": slotGroup.length > 1,
                              "tee-time-slots_last": teetime.slots.length === groupIndex + 1,
                            })}
                            style={
                              {
                                "--slot-group-span": slotGroup.length,
                              } as React.CSSProperties
                            }
                            key={slotId}
                          >
                            {slotGroup.map(
                              (slot, slotIndex: number) => {
                                // BOOKED SLOT
                                if (slot.customer_id) {
                                  return (
                                    <div
                                      key={slotIndex}
                                      className={classNames("tee-time-slot", {
                                        ...getTeeTimeSlotWrapJoinClasses(slotIndex, slotGroup.length),
                                        "tee-time-slot_checked": slot.check_in_status === "checked",
                                        "tee-time-slot_crossover": slot.blocked_type === "crossover",
                                        "tee-time-slot_blocked": slot.blocked_type === "blocked",
                                        "tee-time-slot_arrived": slot.check_in_status === "arrived",
                                        "tee-time-slot_no-show": slot.no_show_type !== null,
                                        "tee-time-slot_turn": slot.turn,
                                        "tee-time-slot_no-show-weather": slot.no_show_type === "weather",
                                        "tee-time-slot_booking_engine":
                                          slot.tee_time_bookings_source === "booking_engine",
                                        "tee-time-slot_has_notes": slot.has_notes,
                                        "tee-time-slot_customer-type-display":
                                          facilityStore?.teeSheetSettings?.display_customer_type,
                                        "tee-time-slot-highlight":
                                          facilityStore.teeSheetSettings.highlight_new_bookings &&
                                          moment
                                            .utc(slot.tee_time_bookings_completed_at)
                                            .local()
                                            .isSameOrAfter(
                                              moment().subtract({
                                                hours: facilityStore?.teeSheetSettings.highlight_new_bookings_window,
                                              }),
                                            ) &&
                                          moment
                                            .utc(slot.tee_time_bookings_completed_at)
                                            .local()
                                            .isSameOrBefore(moment()) &&
                                          slot.check_in_status === "unchecked",
                                      })}
                                      style={{ backgroundColor: findCustomerTypeBackground(slot) }}
                                      onClick={() => openPowerCartModal(teetime)}
                                    >
                                      <div className="tee-time-slot_content">
                                        {tabletBookingParticipantLayout ? (
                                          <BookingParticipantTabletLayout
                                            header={
                                              <BookingParticipantName
                                                firstName={slot.customer_first_name}
                                                lastName={slot.customer_last_name}
                                                divisionWidth={divisionWidth}
                                              >
                                                {slot.guest ? (
                                                  <FontAwesomeIcon
                                                    style={{ marginLeft: "0.25rem" }}
                                                    icon={faCircleG}
                                                    size="1x"
                                                  />
                                                ) : null}
                                                {slot.has_high_priority_notes && !slot.guest ? (
                                                  <OverlayTrigger
                                                    placement="auto"
                                                    overlay={
                                                      <Tooltip id={"high_priority_notes"}>
                                                        {highPriorityNotes?.loading ? (
                                                          <div
                                                            style={{
                                                              height: "20px",
                                                              width: "20px",
                                                              filter: "brightness(0) invert(1)",
                                                            }}
                                                          >
                                                            <Spin />
                                                          </div>
                                                        ) : (
                                                          highPriorityNotes?.notes?.map((note, index, notes) => {
                                                            return (
                                                              <React.Fragment key={index}>
                                                                <p
                                                                  style={{
                                                                    textAlign: "left",
                                                                    marginBottom:
                                                                      index === notes?.length - 1 ? undefined : "1rem",
                                                                  }}
                                                                >
                                                                  {note.content}
                                                                  {note.created_at ? (
                                                                    <>
                                                                      <br />
                                                                      {moment(note.created_at).format("LLL")}
                                                                    </>
                                                                  ) : null}
                                                                </p>
                                                              </React.Fragment>
                                                            );
                                                          })
                                                        )}
                                                      </Tooltip>
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      style={{ marginLeft: "0.25rem" }}
                                                      icon={faExclamationCircle}
                                                      size="1x"
                                                      className="text-error"
                                                      onMouseEnter={() => getHighPriorityNote(slot?.customer_id)}
                                                      onMouseLeave={cancelGetHighPriorityNote}
                                                      onClick={e => e.stopPropagation()}
                                                    />
                                                  </OverlayTrigger>
                                                ) : null}
                                                {slot.restricted ? (
                                                  <FontAwesomeIcon
                                                    style={{ marginLeft: "0.25rem" }}
                                                    icon={faTriangleExclamation}
                                                    size="1x"
                                                    className="text-warning"
                                                  />
                                                ) : null}
                                              </BookingParticipantName>
                                            }
                                            customerType={
                                              <div className="booking-participant-customer-type">
                                                {facilityStore?.teeSheetSettings?.display_customer_type &&
                                                  !slot.guest ? (
                                                  <>
                                                    <span>{slot.customer_type_title}</span>
                                                    {slot.customer_type_subtitle ? (
                                                      <span>{` - ${slot.customer_type_subtitle}`}</span>
                                                    ) : null}
                                                  </>
                                                ) : (
                                                  <span className="booking-participant-customer-type-placeholder">
                                                    &nbsp;
                                                  </span>
                                                )}
                                              </div>
                                            }
                                            bookingSource={
                                              <BookingSourceLogo
                                                source={slot.tee_time_bookings_source}
                                                withBackground
                                              />
                                            }
                                            meta={
                                              <>
                                                <span className="booking-participant-holes-tablet">
                                                  {slot.tee_time_bookings_holes}
                                                </span>
                                                <span className="booking-participant_tablet-equipment">
                                                  {slot.riding ? (
                                                    <span className="booking-participant_icon booking-participant_icon--inline">
                                                      <CustomIcon
                                                        src="../../../public/images/powercart2-01.svg"
                                                        size="small"
                                                      />
                                                      {slot?.inventory_power_cart_number || slot?.power_cart_number ? (
                                                        <span className="booking-participant_icon-label">
                                                          {slot.inventory_power_cart_number ?? slot.power_cart_number}
                                                        </span>
                                                      ) : null}
                                                    </span>
                                                  ) : (
                                                    <FontAwesomeIcon
                                                      icon={faPersonWalking}
                                                      className="booking-participant_icon"
                                                    />
                                                  )}
                                                  {slot.bag_number !== null ? (
                                                    <span className="booking-participant_icon booking-participant_icon--inline">
                                                      <CustomIcon
                                                        src="../../../public/images/golf-bag.svg"
                                                        size="small"
                                                      />
                                                      <span className="booking-participant_icon-label">
                                                        {slot.bag_number}
                                                      </span>
                                                    </span>
                                                  ) : null}
                                                </span>
                                              </>
                                            }
                                            status={
                                              <>
                                                <BookingSourceIcon source={slot.tee_time_bookings_source} />
                                                {showTabletBookingNoteIcon && slot.has_notes && !slot.guest ? (
                                                  <FontAwesomeIcon
                                                    icon={faStickyNote}
                                                    className="booking-participant_icon"
                                                  />
                                                ) : null}
                                                {renderBookingParticipantIcons(slot, {
                                                  includeHoles: false,
                                                  hideCheckInStatusIcons: compactTabletSizedDivision,
                                                })}
                                              </>
                                            }
                                          />
                                        ) : (
                                          <div className="tee-time-slot-booking-participant">
                                            <div className="booking-participant_content">
                                              {!mobileSizedDivision && renderBookingParticipantIcons(slot)}

                                              <div>
                                                <BookingParticipantName
                                                  firstName={slot.customer_first_name}
                                                  lastName={slot.customer_last_name}
                                                  divisionWidth={divisionWidth}
                                                >
                                                  {slot.guest ? (
                                                    <FontAwesomeIcon
                                                      style={{ marginLeft: "0.5rem" }}
                                                      icon={faCircleG}
                                                      size="1x"
                                                    />
                                                  ) : null}
                                                  {!mobileSizedDivision &&
                                                  slot.has_high_priority_notes &&
                                                  !slot.guest ? (
                                                    <OverlayTrigger
                                                      placement="auto"
                                                      overlay={
                                                        <Tooltip id={"high_priority_notes"}>
                                                          {highPriorityNotes?.loading ? (
                                                            <div
                                                              style={{
                                                                height: "20px",
                                                                width: "20px",
                                                                filter: "brightness(0) invert(1)",
                                                              }}
                                                            >
                                                              <Spin />
                                                            </div>
                                                          ) : (
                                                            highPriorityNotes?.notes?.map((note, index, notes) => {
                                                              return (
                                                                <React.Fragment key={index}>
                                                                  <p
                                                                    style={{
                                                                      textAlign: "left",
                                                                      marginBottom:
                                                                        index === notes?.length - 1
                                                                          ? undefined
                                                                          : "1rem",
                                                                    }}
                                                                  >
                                                                    {note.content}
                                                                    {note.created_at ? (
                                                                      <>
                                                                        <br />
                                                                        {moment(note.created_at).format("LLL")}
                                                                      </>
                                                                    ) : null}
                                                                  </p>
                                                                </React.Fragment>
                                                              );
                                                            })
                                                          )}
                                                        </Tooltip>
                                                      }
                                                    >
                                                      <FontAwesomeIcon
                                                        style={{ marginLeft: "0.5rem" }}
                                                        icon={faExclamationCircle}
                                                        size="1x"
                                                        className="text-error"
                                                        onMouseEnter={() => getHighPriorityNote(slot?.customer_id)}
                                                        onMouseLeave={cancelGetHighPriorityNote}
                                                        onClick={e => e.stopPropagation()}
                                                      />
                                                    </OverlayTrigger>
                                                  ) : null}
                                                  {slot.restricted ? (
                                                    <FontAwesomeIcon
                                                      style={{ marginLeft: "0.5rem" }}
                                                      icon={faTriangleExclamation}
                                                      size="1x"
                                                      className="text-warning"
                                                    />
                                                  ) : null}
                                                </BookingParticipantName>

                                                {facilityStore?.teeSheetSettings?.display_customer_type &&
                                                !slot.guest ? (
                                                  <div className="booking-participant-customer-type">
                                                    <span>{slot.customer_type_title}</span>
                                                    {slot.customer_type_subtitle ? (
                                                      <span>{` - ${slot.customer_type_subtitle}`}</span>
                                                    ) : null}
                                                  </div>
                                                ) : null}
                                              </div>
                                            </div>

                                            <div className="booking-participant-secondary_content">
                                              {mobileSizedDivision && (
                                                <div className="booking-participant-holes-small">
                                                  {slot.tee_time_bookings_holes}
                                                </div>
                                              )}
                                              <div className="booking-participant-secondary_content-icons">
                                                {mobileSizedDivision && renderBookingParticipantIcons(slot)}

                                                <BookingSourceIcon source={slot.tee_time_bookings_source} />

                                                <BookingSourceLogo
                                                  source={slot.tee_time_bookings_source}
                                                  withBackground
                                                />

                                                {!mobileSizedDivision && slot.has_notes && !slot.guest ? (
                                                  <FontAwesomeIcon
                                                    icon={faStickyNote}
                                                    className="booking-participant_icon"
                                                  />
                                                ) : null}

                                                {slot.riding ? (
                                                  <div className="booking-participant_icon flex flex-col items-center">
                                                    <CustomIcon
                                                      src="../../../public/images/powercart2-01.svg"
                                                      size="small"
                                                    />
                                                    {!mobileSizedDivision &&
                                                    (slot?.inventory_power_cart_number || slot?.power_cart_number) ? (
                                                      <div className="text-xs">
                                                        {slot.inventory_power_cart_number ?? slot.power_cart_number}
                                                      </div>
                                                    ) : null}
                                                  </div>
                                                ) : (
                                                  <FontAwesomeIcon
                                                    icon={faPersonWalking}
                                                    className="booking-participant_icon"
                                                  />
                                                )}

                                                {slot.bag_number !== null && (
                                                  <CustomIcon src="../../../public/images/golf-bag.svg" size="small" />
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                } else {
                                  // UNBOOKED TEE TIME
                                  return (
                                    <div
                                      key={slotIndex}
                                      className={classNames("tee-time-slot", {
                                        "tee-time-slot_crossover":
                                          slot.blocked_type === "crossover" ||
                                          slot.blocked_type === "shotgun_crossover",
                                        "tee-time-slot_blocked":
                                          slot.blocked_type === "blocked" ||
                                          slot.blocked_type === "shotgun_blocked" ||
                                          slot.blocked_type === "shotgun_disabled",
                                        "tee-time-slot_no-show": slot.no_show_type && slot.no_show_type !== "weather",
                                        "tee-time-slot_no-show-weather": slot.no_show_type === "weather",
                                        "tee-time-slot_customer-type-display":
                                          facilityStore?.teeSheetSettings?.display_customer_type,
                                      })}
                                      style={{ cursor: "default" }}
                                    >
                                      {/* <TeeTimeToolTip
                                                prepaidRequired={false}
                                                cardRequired={false}
                                                parentId={slot.tee_time_slot_id}
                                                onMouseEnter={(token) => handleMouseEnter(teetime, token)}
                                                disable={props.dragAndDropState.teetimeToolTipDisabled}
                                              > */}
                                      <div
                                        className={classNames("tee-time-slot_content", {
                                          "tee-time-slot_content--tablet-empty": tabletBookingParticipantLayout,
                                        })}
                                        style={
                                          tabletBookingParticipantLayout
                                            ? undefined
                                            : {
                                              height:
                                                slot?.blocked_type === "open" || slot?.blocked_type === "shotgun"
                                                  ? "100%"
                                                  : undefined,
                                            }
                                        }
                                      >
                                        {tabletBookingParticipantLayout ? (
                                          <>
                                            {slot.blocked_type !== null && slot.blocked_type !== "open" ? (
                                              slot.blocked_type === "shotgun_disabled" ? (
                                                <em>{t("Blocked for shotgun")}</em>
                                              ) : (
                                                <FontAwesomeIcon
                                                  icon={
                                                    slot.blocked_type === "crossover" ||
                                                      slot.blocked_type === "shotgun_crossover"
                                                      ? faRepeatAlt
                                                      : faBan
                                                  }
                                                  className="booking-participant_icon"
                                                />
                                              )
                                            ) : (
                                              <FontAwesomeIcon
                                                icon={faPlusCircle}
                                                className="booking-participant_icon"
                                              />
                                            )}
                                          </>
                                        ) : slot.blocked_type !== null && slot.blocked_type !== "open" ? (
                                          <div className="">
                                            {slot.blocked_type === "blocked" && (
                                              <p className="text-center">
                                                <FontAwesomeIcon icon={faBan} className="booking-participant_icon" />
                                              </p>
                                            )}

                                            {slot.blocked_type === "crossover" && (
                                              <p className="text-center">
                                                <FontAwesomeIcon
                                                  icon={faRepeatAlt}
                                                  className="booking-participant_icon"
                                                />
                                              </p>
                                            )}

                                            {slot.blocked_type === "shotgun" && (
                                              <div className="flex justify-center items-center h-full">
                                                <Badge type="gray" size="small">
                                                  {t("Available")}
                                                </Badge>
                                              </div>
                                            )}

                                            {slot.blocked_type === "shotgun_blocked" && (
                                              <p className="text-center">
                                                <FontAwesomeIcon icon={faBan} className="booking-participant_icon" />
                                              </p>
                                            )}

                                            {slot.blocked_type === "shotgun_disabled" && (
                                              <p className="text-center">
                                                <em>{t("Blocked for shotgun")}</em>
                                              </p>
                                            )}

                                            {slot.blocked_type === "shotgun_crossover" && (
                                              <p className="text-center">
                                                <FontAwesomeIcon
                                                  icon={faRepeatAlt}
                                                  className="booking-participant_icon"
                                                />
                                              </p>
                                            )}
                                          </div>
                                        ) : (
                                          <div className="flex justify-center items-center h-full">
                                            <Badge type="gray" size="small">
                                              {t("Available")}
                                            </Badge>
                                          </div>
                                        )}
                                      </div>
                                      {/* </TeeTimeToolTip> */}
                                    </div>
                                  );
                                }
                              }, // slot group map
                            )}
                          </div> // tee-time-slots_container
                        );
                      },
                    )}
                  </span>
                </div>
                {!mobileSizedDivision && renderBookingCategoryIcons(teetime?.slots?.[0]?.tee_time_id)}
              </div>

              {/* SUNSET MARKER */}
              {((teetimeIndex === teetimes.length - 1 && sunsetLineTime > teetime?.start_time) ||
                (sunsetLineTime <= nextTeetime?.start_time && sunsetLineTime > teetime?.start_time)) && (
                <div className="flex items-center mt-3.5 mb-3.5">
                  <div className="sun-time-line"></div>
                  <span className="sun-time-hour">
                    <FontAwesomeIcon icon={faSunset} className="booking-participant_icon mt-1" />
                    {convertTime(facilityStore.weather?.sunset)}
                  </span>
                  <div style={{ marginRight: "8px" }} className="sun-time-line"></div>
                </div>
              )}
            </div>
          </Fragment>
        );
      })}

      {/* MOBILE/TABLET VIEW */}
      <Portal isMounted>
        <Panel
          open={powerCartModal?.isOpen && windowSize.width <= SMALL_DESKTOP_WIDTH}
          title={powerCartModal?.signWaiverPage ? t("Sign Waiver") : t("Tee Time Details")}
          subtitle={powerCartModal?.signWaiverPage ? t("View the cart waiver details, check the box and sign to confirm your acknowledgement") : undefined}
          onClose={closePowerCartModal}
          animate
          pagePercent={100}
          primaryAction={{
            onClick: powerCartModal?.signWaiverPage && powerCartModal?.signatureData ? undefined : powerCartModal?.signWaiverPage ? () => confirmSignWaiver() : () => savePowerCartNumbers(),
            label: powerCartModal?.signWaiverPage ? t("Confirm Signature") : t("Save"),
            disabled: powerCartModal?.signWaiverPage ? !powerCartModal?.agreeToWaiver : facilityStore.teeSheetSettings?.use_cart_inventory && !powerCartModal?.powerCarts,
          }}
          secondaryAction={{
            onClick: powerCartModal?.signWaiverPage ? () => updatePowerCartModal({ signWaiverPage: false, waiverParticipant: null, agreeToWaiver: false, signatureData: null }) : () => closePowerCartModal(),
            label: powerCartModal?.signWaiverPage ? t("Go Back") : t("Cancel"),
          }}
        >
          <div className="flex items-center gap-6 mb-4">
            <span className="hour-size">
              {powerCartModal?.selectedTeeTime?.start_time
                ? convertTime(powerCartModal.selectedTeeTime.start_time)
                : null}
            </span>
            <span className="text-primary-grey text-m">|</span>
            <span className="text-primary-grey text-m">
              {moment(`${powerCartModal?.selectedTeeTime?.slots?.[0]?.date}`).format("MMMM Do, YYYY")}
            </span>
            <span className="text-primary-grey text-m">|</span>
            <Badge size="small" type="gray">
              {props.allDivisions?.find(d => d.id === powerCartModal?.selectedTeeTime?.slots?.[0]?.division_id)?.title}
              <FontAwesomeIcon icon={["far", "long-arrow-right"]} className="mr-1 ml-1" />
              {
                props.allDivisions?.find(d => d.id === powerCartModal?.selectedTeeTime?.slots?.[0]?.turn_division_id)
                  ?.title
              }
            </Badge>
          </div>
          {renderTeeTimeDetailsModal()}
        </Panel>
      </Portal>

      {/* DESKSTOP VIEW */}
      <Portal isMounted={powerCartModal?.isOpen && windowSize.width > SMALL_DESKTOP_WIDTH}>
        <Sheet
          size="medium"
          height="flexible"
          closable
          supportText={powerCartModal?.signWaiverPage ? t("View the cart waiver details, check the box and sign to confirm your acknowledgement") : undefined}
          title={
            powerCartModal?.signWaiverPage ? t("Sign Waiver") :
              <>
                {t("Tee Time Details")}
                <div className="flex items-center gap-6 mt-2">
                  <span className="hour-size">
                    {powerCartModal?.selectedTeeTime?.start_time
                      ? convertTime(powerCartModal.selectedTeeTime.start_time)
                      : null}
                  </span>
                  <span className="text-primary-grey text-m">|</span>
                  <span className="text-primary-grey text-m">
                    {moment(`${powerCartModal?.selectedTeeTime?.slots?.[0]?.date}`).format("MMMM Do, YYYY")}
                  </span>
                  <span className="text-primary-grey text-m">|</span>
                  <Badge size="small" type="gray">
                    {
                      props.allDivisions?.find(d => d.id === powerCartModal?.selectedTeeTime?.slots?.[0]?.division_id)
                        ?.title
                    }
                    <FontAwesomeIcon icon={["far", "long-arrow-right"]} className="mr-1 ml-1" />
                    {
                      props.allDivisions?.find(
                        d => d.id === powerCartModal?.selectedTeeTime?.slots?.[0]?.turn_division_id,
                      )?.title
                    }
                  </Badge>
                </div>
              </>
          }
          open={powerCartModal?.isOpen && windowSize.width > SMALL_DESKTOP_WIDTH}
          okText={powerCartModal?.signWaiverPage ? t("Confirm Signature") : t("Save")}
          cancelText={powerCartModal?.signWaiverPage ? t("Go Back") : t("Cancel")}
          onOk={powerCartModal?.signWaiverPage && powerCartModal?.signatureData ? undefined : powerCartModal?.signWaiverPage ? () => confirmSignWaiver() : () => savePowerCartNumbers()}
          onCancel={powerCartModal?.signWaiverPage ? () => updatePowerCartModal({ signWaiverPage: false, waiverParticipant: null, agreeToWaiver: false, signatureData: null }) : () => closePowerCartModal()}
          okDisabled={powerCartModal?.signWaiverPage ? !powerCartModal?.agreeToWaiver : facilityStore.teeSheetSettings?.use_cart_inventory && !powerCartModal?.powerCarts}
        >
          {renderTeeTimeDetailsModal()}
        </Sheet>
      </Portal>
    </div>
  );
}
